module.exports = __webpack_public_path__ + "static/media/2019_IMG_2052.08abc78e.jpg";